import * as React from "react";
import {
  Path,
  Rect,
  G,
  Defs,
  ClipPath,
  LinearGradient,
  Stop,
  Mask,
} from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const CYIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="CY" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#F7FCFF"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#F57A01"
          fillRule="evenodd"
          d="M12.284 2.38S9.643 3.839 9.31 3.93c-.332.093-.11.149-.683.112-.573-.037-1.7.206-1.958.04-.258-.167-.35-.462-.369.037-.019.498.388.923-.13.96-.516.037-.572-.444-.923-.148-.35.295-.646.96-.868.794-.221-.166-.535-.61-.443-.185.092.425.37 1.495 1.256 1.513.886.019 1.071-.295 1.108-.036.037.258.425.295.517-.037.092-.333.85.37 1.256.02.406-.351.739-.647.868-.85.13-.203.572-.166.997-.166.425 0 1.053.184.72-.222-.332-.406-.905-.59-.572-.997.332-.406 3.153-1.757 3.283-1.905.129-.148-.698-.702-1.085-.48Z"
          clipRule="evenodd"
        />
        <Path
          fill="url(#c)"
          fillRule="evenodd"
          d="M12.284 2.38S9.643 3.839 9.31 3.93c-.332.093-.11.149-.683.112-.573-.037-1.7.206-1.958.04-.258-.167-.35-.462-.369.037-.019.498.388.923-.13.96-.516.037-.572-.444-.923-.148-.35.295-.646.96-.868.794-.221-.166-.535-.61-.443-.185.092.425.37 1.495 1.256 1.513.886.019 1.071-.295 1.108-.036.037.258.425.295.517-.037.092-.333.85.37 1.256.02.406-.351.739-.647.868-.85.13-.203.572-.166.997-.166.425 0 1.053.184.72-.222-.332-.406-.905-.59-.572-.997.332-.406 3.153-1.757 3.283-1.905.129-.148-.698-.702-1.085-.48Z"
          clipRule="evenodd"
        />
        <Path
          fill="#006B49"
          d="M10.625 8.052c1.31 0-.946 2.124-2.405 2.124a.928.928 0 0 1-.274-.081.934.934 0 0 1-.273.081c-1.46 0-3.528-2.124-2.217-2.124 1.31 0 2.438 1.459 2.438 1.459.02.02.036.04.052.058.017-.019.033-.039.053-.058 0 0 1.315-1.459 2.626-1.459Z"
        />
        <Path
          fill="url(#d)"
          d="M10.625 8.052c1.31 0-.946 2.124-2.405 2.124a.928.928 0 0 1-.274-.081.934.934 0 0 1-.273.081c-1.46 0-3.528-2.124-2.217-2.124 1.31 0 2.438 1.459 2.438 1.459.02.02.036.04.052.058.017-.019.033-.039.053-.058 0 0 1.315-1.459 2.626-1.459Z"
        />
      </G>
    </G>
    <Defs>
      <LinearGradient
        id="c"
        x1={15}
        x2={15}
        y1={9}
        y2={1}
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="#EA5113" />
        <Stop offset={1} stopColor="#FC9B58" />
      </LinearGradient>
      <LinearGradient
        id="d"
        x1={11.019}
        x2={11.019}
        y1={10.176}
        y2={8.052}
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="#008057" />
        <Stop offset={1} stopColor="#00B77C" />
      </LinearGradient>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
